import {
  ForwardedRef,
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { RegistrationFieldProps } from '../../RegistrationField.types';
import { Box, Input, Text, TextInput } from '@bonanza-social/moonlight';

function BirthDatePicker(
  { value, onValue, onSubmitEditing }: RegistrationFieldProps<'birthDate'>,
  _: ForwardedRef<TextInput>,
) {
  const [rawDate, setRawDate] = useState('');

  const formatInput = (text: string) => {
    const cleaned = text.replace(/\D/g, '').slice(0, 8);

    const mm = cleaned.slice(0, 2);
    const dd = cleaned.slice(2, 4);
    const yyyy = cleaned.slice(4, 8);

    let formatted = mm;
    if (dd) formatted += '/' + dd;
    if (yyyy) formatted += '/' + yyyy;

    return formatted;
  };

  const parseToIso = (formatted: string) => {
    const [mm, dd, yyyy] = formatted.split('/');
    if (mm?.length === 2 && dd?.length === 2 && yyyy?.length === 4) {
      return `${yyyy}-${mm}-${dd}`;
    }
    return '';
  };

  const onChange = useCallback((text: string) => {
    const formatted = formatInput(text);
    setRawDate(formatted);

    const iso = parseToIso(formatted);
    if (iso) {
      onValue(iso);
    }
  }, []);

  useEffect(() => {
    if (value) {
      const [yyyy, mm, dd] = value.split('-');
      const formatted = `${mm}/${dd}/${yyyy}`;
      setRawDate(formatted);
    }
  }, []);

  return (
    <Box>
      <Text
        color="darkSurfacePrimary"
        marginBottom="space-300"
        variant="h5"
        locNS="registration"
        locKey="dateOfBirthLabel"
      />
      <Input
        keyboardType="numeric"
        placeholderNS="registration"
        placeholderKey="DoB"
        value={rawDate}
        onChangeText={onChange}
        enterKeyHint="go"
        onSubmitEditing={onSubmitEditing}
        autoComplete="birthdate-full"
      />
    </Box>
  );
}

export default memo(forwardRef(BirthDatePicker));
